export const formatArrayToMultipleWordsSeparatedByComma = (words: string[]): string => {
  const phrase = words.join(', ');

  const lastIndexOfComma = phrase.lastIndexOf(', ');

  if (lastIndexOfComma === -1) return phrase;

  return `${phrase.substring(0, lastIndexOfComma)} e ${phrase.substring(0, lastIndexOfComma + 1)}`;
};

export const truncate = (text: string | undefined, maxLength: number): string => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};
